export default __webpack_public_path__ + "static/media/_arrow-circle.23b102d6.svg";